import React from 'react';
import BrandPolicyPage from '../PolicyPage/BrandPolicyPage';

const AccountDeletionPage: React.FC = () => <BrandPolicyPage doc="account-deletion" />;

export default AccountDeletionPage;
